try {
  console.log("[info] CyberCloud App process.env.PACK_TIME", process.env.PACK_TIME);
} catch {
  // do nothing
}

import("./bootstrap");
